import { render, staticRenderFns } from "./PreApprovalForm.vue?vue&type=template&id=f3246c68&scoped=true"
import script from "./PreApprovalForm.vue?vue&type=script&lang=js"
export * from "./PreApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./PreApprovalForm.vue?vue&type=style&index=0&id=f3246c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3246c68",
  null
  
)

export default component.exports